import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaCheck, FaHandshake, FaCarAlt, FaUserFriends, FaClock, FaRocket } from 'react-icons/fa';

const AboutUs = () => {
    return (
        <div className="about-us-page">
            {/* Header Section - Elegant & Clean */}
            <section className="py-5">
                <Container>
                    <div className="text-center mb-5">
                        <h1 className="section-title">HAKKIMIZDA</h1>
                        <p className="lead mb-4">
                            <strong>2005'ten Gelen Tecrübe, 2020'den Beri Otomotivde Güvenin Adı</strong>
                        </p>
                    </div>

                    <Row className="justify-content-center">
                        <Col lg={10}>
                            <div className="about-content text-center">
                                <p className="mb-4" style={{ fontSize: 'var(--font-lg)', lineHeight: '1.7' }}>
                                    OtoPrime, kurucu ekibinin 2005 yılından bu yana sürdürdüğü emlak ve ticaret alanındaki
                                    deneyimi üzerine inşa edilerek, 2020 yılında otomotiv sektörüne adım atmıştır.
                                    Kurulduğu günden bu yana ikinci el otomobil alım-satımı, takas ve kredi danışmanlığı
                                    alanlarında güvenilir, şeffaf ve çözüm odaklı hizmet sunmayı amaç edinmiştir.
                                </p>

                                <div className="mb-5">
                                    <p className="mb-3" style={{ fontSize: 'var(--font-lg)', fontWeight: '600' }}>
                                        Bugün hem bireysel hem kurumsal müşterilerimize:
                                    </p>
                                    <Row className="g-3 justify-content-center">
                                        <Col md={6} lg={3}>
                                            <div className="modern-advantage-card text-center">
                                                <div className="advantage-icon-modern mb-2">
                                                    <FaCheck />
                                                </div>
                                                <p className="mb-0 font-semibold">Belgeli ve Güvenilir Araçlar</p>
                                            </div>
                                        </Col>
                                        <Col md={6} lg={3}>
                                            <div className="modern-advantage-card text-center">
                                                <div className="advantage-icon-modern mb-2">
                                                    <FaRocket />
                                                </div>
                                                <p className="mb-0 font-semibold">Krediye Uygun Finansal Çözümler</p>
                                            </div>
                                        </Col>
                                        <Col md={6} lg={3}>
                                            <div className="modern-advantage-card text-center">
                                                <div className="advantage-icon-modern mb-2">
                                                    <FaCarAlt />
                                                </div>
                                                <p className="mb-0 font-semibold">Ekspertiz ve Takas Desteği</p>
                                            </div>
                                        </Col>
                                        <Col md={6} lg={3}>
                                            <div className="modern-advantage-card text-center">
                                                <div className="advantage-icon-modern mb-2">
                                                    <FaUserFriends />
                                                </div>
                                                <p className="mb-0 font-semibold">Kurumsal Satış Danışmanlığı</p>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>

                                <p className="mb-4" style={{ fontSize: 'var(--font-lg)', lineHeight: '1.7' }}>
                                    gibi birçok hizmeti bir arada sunarak sadece araç değil, <strong>güven</strong> satıyoruz.
                                </p>

                                <p style={{ fontSize: 'var(--font-lg)', lineHeight: '1.7' }}>
                                    2025 itibarıyla dijital altyapımızı da güçlendirdik. OtoPrime artık sadece galeride değil,
                                    internetin olduğu her yerde yanınızda.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Features Section - Using existing CSS */}
            <section className="modern-advantages-section py-5 bg-light">
                <Container>
                    <div className="text-center mb-5">
                        <h2 className="section-title">Dijital Avantajlarımız</h2>
                    </div>

                    <Row className="g-4">
                        <Col lg={3} md={6}>
                            <div className="modern-step-card">
                                <div className="step-icon-modern">
                                    <FaCheck />
                                </div>
                                <h4 className="step-title-modern">Online Peşinat Ödeme İmkanı</h4>
                                <p className="step-description-modern">
                                    Evden çıkmadan, hızlı ve güvenli bir şekilde peşinat ödemelerinizi yapabilirsiniz.
                                </p>
                            </div>
                        </Col>
                        <Col lg={3} md={6}>
                            <div className="modern-step-card">
                                <div className="step-icon-modern">
                                    <FaClock />
                                </div>
                                <h4 className="step-title-modern">Kolay ve Hızlı Değerlendirme Süreci</h4>
                                <p className="step-description-modern">
                                    Başvurularınız uzman ekibimiz tarafından en kısa sürede değerlendirilir.
                                </p>
                            </div>
                        </Col>
                        <Col lg={3} md={6}>
                            <div className="modern-step-card">
                                <div className="step-icon-modern">
                                    <FaHandshake />
                                </div>
                                <h4 className="step-title-modern">Aracı Kurum Yok, Doğrudan Başvuru</h4>
                                <p className="step-description-modern">
                                    Ekstra komisyon ve aracı maliyeti olmadan doğrudan bizimle iletişime geçebilirsiniz.
                                </p>
                            </div>
                        </Col>
                        <Col lg={3} md={6}>
                            <div className="modern-step-card">
                                <div className="step-icon-modern">
                                    <FaRocket />
                                </div>
                                <h4 className="step-title-modern">Hızlı Teslimat Kolaylığı</h4>
                                <p className="step-description-modern">
                                    Onaylanan finansman işlemleriniz sonrası aracınızı hızlıca teslim alabilirsiniz.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Mission & Vision Section - Simplified */}
            <section className="py-5">
                <Container>
                    <Row>
                        <Col lg={6} className="mb-4">
                            <div className="modern-faq-item">
                                <h3 className="modern-faq-question">
                                    <FaHandshake className="me-3" style={{ color: 'var(--black)' }} />
                                    MİSYONUMUZ
                                </h3>
                                <div className="modern-faq-answer">
                                    <p><strong>Güven ve Şeffaflık:</strong> Müşterilerimizle dürüst ve açık iletişim kurarak güven temelli ilişkiler inşa ederiz.</p>
                                    <p><strong>Kaliteli Hizmet:</strong> Her müşteri için özel çözümler sunarak otomobil alım-satım sürecini kolaylaştırırız.</p>
                                    <p><strong>Müşteri Memnuniyeti:</strong> Müşterilerimizin ihtiyaçlarını en iyi şekilde anlayarak, beklentilerinin ötesinde hizmet sunarız.</p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="mb-4">
                            <div className="modern-faq-item">
                                <h3 className="modern-faq-question">
                                    <FaRocket className="me-3" style={{ color: 'var(--black)' }} />
                                    VİZYONUMUZ
                                </h3>
                                <div className="modern-faq-answer">
                                    <p><strong>Sektör Liderliği:</strong> Türkiye'nin en güvenilir ve tercih edilen ikinci el otomobil finansman markası olmak.</p>
                                    <p><strong>Yenilikçi Çözümler:</strong> Teknolojik yenilikleri takip ederek müşterilerimize her zaman en yeni ve en iyi hizmeti sunmak.</p>
                                    <p><strong>Sürdürülebilir Büyüme:</strong> Müşteri memnuniyetini esas alarak, etik değerlerden taviz vermeden büyümeyi sürdürmek.</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Team Section - Simplified */}
            <section className="py-5 bg-light">
                <Container>
                    <div className="text-center">
                        <h2 className="section-title">EKİBİMİZ</h2>
                        <Row className="justify-content-center">
                            <Col lg={8}>
                                <p className="lead">
                                    OtoPrime, alanında uzman, deneyimli ve dinamik bir ekiple hizmet vermektedir.
                                    Otomotiv sektöründe uzun yıllar deneyimi olan ekibimiz, sizlere en iyi hizmeti
                                    sunmak için burada.
                                </p>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </section>
        </div>
    );
};

export default AboutUs;